export default __webpack_public_path__ + "static/media/shop.5c24990e.svg";